import { CapoPlugin } from "/workd/WORKD/PROJECT_AIMI/aimi-barcode-n3/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];